import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { ReactComponent as GrayXIcon } from '@Assets/icons/gray-x-icon.svg';

interface BusinessAddressExplanationProps {
  isUS: boolean;
}

export const BusinessAddressExplanation = ({ isUS: _isUS }: BusinessAddressExplanationProps) => {
  const { t } = useTranslation();
  return (
    <div className='mb-[24px] flex flex-col gap-[8px]'>
      <Text.H10 className='text-text-main-secondary'>
        {t('pages.businessAddress.explanation')}
      </Text.H10>
      <div className='flex items-start gap-[8px]'>
        <GrayXIcon className='shrink-0' />
        <Text.H10 className='text-text-main-secondary'>
          {t('pages.businessAddress.raForbidden')}
        </Text.H10>
      </div>
    </div>
  );
};
